import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { set } from 'lodash';


interface suesState {
    reloadSuesData: boolean;
    sueInsuranceCompanyId: string;
    filterCleaned: boolean;
    suesDataList: any[];
    totalItemsCount: number;
    pageSizeSues: number;
}

const initialState: suesState = {
    reloadSuesData: false,
    sueInsuranceCompanyId: '',
    filterCleaned: false,
    suesDataList: [],
    totalItemsCount: 0,
    pageSizeSues: 0,
}

export const suesSlice = createSlice({
    name: 'suesSlice',
    initialState,
    reducers: {
        setReloadSuesData: (state, action: PayloadAction<boolean>) => {
            state.reloadSuesData = action.payload;
        },
        setSueInsuranceCompanyId: (state, action: PayloadAction<string>) => {
            state.sueInsuranceCompanyId = action.payload;
        },
        setFilterCleaned: (state, action: PayloadAction<boolean>) => {
            state.filterCleaned = action.payload;
        },
        setSuesDataList: (state, action: PayloadAction<any[]>) => {
            state.suesDataList = action.payload;
        },
        setTotalItemsCount: (state, action: PayloadAction<number>) => {
            state.totalItemsCount = action.payload;
        },
        setPageSizeSues: (state, action: PayloadAction<number>) => {
            state.pageSizeSues = action.payload;
        },
    },
})
export const { setReloadSuesData, setSueInsuranceCompanyId, setFilterCleaned, setSuesDataList,
    setTotalItemsCount, setPageSizeSues } = suesSlice.actions
export default suesSlice.reducer